import instObj from '@/backend/axios-instances'

const resource = "/contact"
const instance = instObj.baseInstance

export default {
  get(id) {
    return instance.get(`${resource}/${id}`);
  }
}
